import React, { useCallback, useContext } from 'react'
import { matchUpdateTypes } from '../cnr/reducers/SportsSeasonReducer';
import { useAppUserAccess } from 'global/cnr/contexts/useHelpers/useAppUserAccess';
import { ParentContext } from 'global/cnr/contexts/ParentContext';
import { SportsSeasonContext } from '../cnr/contexts/SportsSeasonContext';
import { updateTheMatch } from '../dbActions/updateMatch';
import { _matchResultTypes } from '../cnr/reducers/SportsMatchReducer';
import { updateParentKeyData_sports } from '../cnr/reducers/reducerHelpers/parentKeySportsData';
import { openExternal } from 'global/viewSettings/helpers/settingsLinks';

export const useMatchUpdate = () => {

  const appUserAccess = useAppUserAccess()

  const parentContext = useContext(ParentContext);
  const { states, fns, fn_cls } = parentContext ?? {}
  const { app_state, paps_state, eventInfo_state } = states
  const { mainRt } = app_state
  const { pathViews } = paps_state
  const { database_fns } = fns

  // sportsSeasonContext
  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state } = sportsSeasonContext ?? {}
  const { currentSeason_info, sportPermissions, sportDataSettings } = sportsSeason_state ?? {}
  const { latestSeason, sportsKey, _sportsYearAbr, _sportsAbr, _sportsModeKey, _sportsModeSport } = currentSeason_info ?? {}

  const handle_updateMatchScore = useCallback(({ match_edit, match_rt, _results, sortedAthletes, playoffMatches, matchResultType, useRtMatchData, updateRtGameDayData, callback }) => {
    const updateProps = {
      match_edit,
      match_rt,
      sortedAthletes,
      _results: _results || match_edit?._results,
      playoffMatches
    }
    const matchProps = {
      actionProps: updateProps,
      appUserInfo: appUserAccess,
      callback: callback,
      database_fns,
      latestSeason,
      matchResultType: matchResultType || _matchResultTypes.normal,
      matchUpdateType: matchUpdateTypes.updateScore,
      pathViews,
      sportDataSettings,
      sportPermissions,
      sportsKey,
      useRtMatchData,
      updateRtGameDayData: updateRtGameDayData,
    }
    updateTheMatch(mainRt, matchProps)
  }, []);

  const handle_updateMatch = useCallback(({ matchPendingUpdate, match_true, match_edit, callback }) => {
    updateMatch(fn_cls, matchPendingUpdate, match_true, match_edit)
  }, []);

  return { handle_updateMatch, handle_updateMatchScore }
}

const updateMatch = (fn_cls, matchPendingUpdate, match_true, match_edit) => {

  matchPendingUpdate.match_true = match_true
  matchPendingUpdate.match_edit = match_edit

  const { matchUpdateType } = matchPendingUpdate
  const actionProps = matchPendingUpdate

  switch (matchUpdateType) {

    case matchUpdateTypes.notifyMatch:
      // const sendProps = appUserAccess ? { profileId: appUserAccess.profileId, fcmTokens: appUserAccess.fcmTokens } : {}
      // const topicData = getNotificationData(notificationTypes.notification, pathViews, { topic: viewKey }, { title: 'Match Results', body: scoreDisplay_full, clickPath: pathName })
      // fsfn_sendNotification(sendProps, topicData, pathViews)
      break;

    case matchUpdateTypes.addToHistory:
      const { startDate, levels } = match_edit
      const results = match_edit ? match_edit._results : undefined;
      const { winner, loser } = results ?? {}
      if (winner && loser) {
        const d = new Date(startDate)
        const year = d.getFullYear()
        const data = {
          [levels]: {
            [year]: {
              winner: winner.name,
              runnerUp: loser.name
            }
          }
        }
        updateParentKeyData_sports(database_fns, sportPermissions, '_history', pathViews, 'history', data, null, sportsKey)
      }
      break;

    case matchUpdateTypes.addConsolationMatch:
      console.log('actionProps', actionProps)
      break;

    case matchUpdateTypes.openDatabase:
      const { _matchCollectionKey, isPlayoff } = match_true ?? {}
      const dbCollection = isPlayoff ? 'playoffMatches' : 'matches'
      openExternal.firebaseDb(pathViews, _sportCollections._matches_seasonal, pk_matches_seasonal, false, false, false, [dbCollection, _matchCollectionKey])
      break;

    case matchUpdateTypes.updateGsScore:
      fn_cls.updateGoogleSheetRow(match_edit)
      break;

    case matchUpdateTypes.deleteMatch:
    case matchUpdateTypes.updateMatchDayMatch:
    case matchUpdateTypes.cancelMatch:
    case matchUpdateTypes.confirmMatchDate:
    case matchUpdateTypes.deleteRealtimeMatch:
    case matchUpdateTypes.removeResults:
    case matchUpdateTypes.postponeMatch:
    case matchUpdateTypes.resetByeMatch:
    case matchUpdateTypes.updateMatchDetails:
    case matchUpdateTypes.updateScore:
      let _matchResultType = _matchResultTypes.normal;
      switch (matchUpdateType) {
        case matchUpdateTypes.updateMatchDayMatch:
          _matchResultType = _matchResultTypes.matchDay
          break;
        default:
        // nothing
      }
      actionProps.realtimeMatch = _realtimeMatch
      const matchPropsOther = {
        actionProps: actionProps,
        appUserInfo,
        callback: action.callback,
        database_fns,
        latestSeason,
        matchResultType: _matchResultType,
        matchUpdateType: matchUpdateType,
        pathViews,
        sportDataSettings,
        sportPermissions,
        sportsKey,
        useRtMatchData,
      }
      updateTheMatch(mainRt, matchPropsOther)
      break;

    case matchUpdateTypes.updatePendingMatch:
      break;

    case matchUpdateTypes.updatePrePendingMatch:
      break;

    default:
      break;
  }
}



// case rts.handleUpdate_matchResults:
//       const updateProps = {
//         match_true,
//         match_edit,
//         sortedAthletes,
//         _results: _results,
//         playoffMatches
//       }
//       const matchProps = {
//         actionProps: updateProps,
//         appUserInfo,
//         currentUserId,
//         callback: action.callback,
//         database_fns,
//         latestSeason,
//         matchResultType: _matchResultTypes.normal,
//         matchUpdateType: matchUpdateTypes.updateScore,
//         pathViews,
//         sportDataSettings,
//         sportPermissions,
//         sportsKey,
//         updateRtGameDayData: action.updateRtGameDayData,
//       }

// const updatePropsRt = { match_true, match_rt: action.match_rt, sortedAthletes, playoffMatches }
// const matchProps = {
//   actionProps: updatePropsRt,
//   appUserInfo: appUserAccess,
//   callback: action.callback,
//   database_fns,
//   latestSeason,
//   matchResultType: action.matchResultType,
//   matchUpdateType: matchUpdateTypes.updateScore,
//   pathViews,
//   sportDataSettings,
//   sportPermissions,
//   sportsKey,
//   useRtMatchData,
// }
// updateTheMatch(mainRt, matchProps)